import { atom } from 'jotai';
import { REVIEW_COMMENT_LEVEL } from '../constants';
import type { ReviewCommentLevelT, ReviewCommentT } from '../types';
import { reviewAnnotationsAtom } from './annotation-review-atoms';
export const commentsAtom = atom<ReviewCommentT[]>([]);
export const commentSelectOptionsAtom = atom<{
  id: string;
  value: string;
  level: ReviewCommentLevelT;
}[]>(get => {
  const reviewAnnotations = get(reviewAnnotationsAtom);
  const options = Object.entries(reviewAnnotations).map(([annotationId, annotation]) => ({
    id: annotationId,
    value: annotation.name ?? annotationId,
    level: REVIEW_COMMENT_LEVEL.ANNOTATION
  }));
  return [{
    id: 'task',
    value: 'Task',
    level: REVIEW_COMMENT_LEVEL.TASK
  }, ...options];
});
export const commentListAtom = atom<{
  label: string;
  description: string;
}[]>(get => {
  const comments = get(commentsAtom);
  const reviewAnnotations = get(reviewAnnotationsAtom);
  return comments.map(({
    comment,
    level,
    annotationId
  }) => {
    if (level === REVIEW_COMMENT_LEVEL.TASK) {
      return {
        label: 'Task',
        description: comment
      };
    }
    const annotationName = reviewAnnotations[annotationId!]?.name ?? annotationId!;
    return {
      label: annotationName,
      description: comment
    };
  });
});